// Keep the browser PDF viewer outside Vue's virtual DOM and event patching.
export function printPdf(pdf, onReady, onError) {
  const url = URL.createObjectURL(pdf);
  const frame = document.createElement('iframe');
  let disposed = false;
  let loaded = false;
  let timer;

  const cleanup = () => {
    if (disposed) return;
    disposed = true;
    clearTimeout(timer);
    frame.removeEventListener('load', load);
    frame.removeEventListener('error', error);
    frame.remove();
    URL.revokeObjectURL(url);
  };
  const error = err => {
    cleanup();
    onError(err);
  };
  const load = () => {
    if (disposed || loaded) return;
    loaded = true;
    // Open the native dialog after the frame's load event has finished.
    timer = setTimeout(() => {
      if (disposed) return;
      try {
        frame.contentWindow.focus();
        frame.contentWindow.print();
        onReady();
      } catch (err) {
        error(err);
      }
    }, 0);
  };

  frame.title = 'Print PDF';
  frame.setAttribute('aria-hidden', 'true');
  frame.tabIndex = -1;
  frame.style.cssText = 'position:fixed;left:-10000px;top:50px;width:1px;height:1px;border:0;';
  frame.addEventListener('load', load);
  frame.addEventListener('error', error);
  frame.src = url;
  try {
    document.body.appendChild(frame);
  } catch (err) {
    cleanup();
    throw err;
  }
  return cleanup;
}



// WEBPACK FOOTER //
// ./src/common/printPdf.js